
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface CourseTemplate {
  id: string;
  title: string;
  description: string | null;
  preview_image_url: string | null;
  topic: string;
}

interface CourseTemplateCardProps {
  template: CourseTemplate;
  onSelect: () => void;
  disabled?: boolean;
}

export function CourseTemplateCard({ template, onSelect, disabled }: CourseTemplateCardProps) {
  return (
    <Card className="overflow-hidden flex flex-col">
      <div className="relative aspect-video">
        <img
          src={template.preview_image_url || '/placeholder.svg'}
          alt={template.title}
          className="object-cover w-full h-full"
        />
      </div>
      <CardHeader>
        <CardTitle className="text-lg">{template.title}</CardTitle>
      </CardHeader>
      <CardContent className="flex-1">
        <p className="text-sm text-muted-foreground">{template.description}</p>
        <p className="text-xs mt-2 text-muted-foreground">Topic: {template.topic}</p>
      </CardContent>
      <CardFooter>
        <Button 
          className="w-full" 
          onClick={onSelect}
          disabled={disabled}
        >
          <Plus className="w-4 h-4 mr-2" />
          Add to My Resources
        </Button>
      </CardFooter>
    </Card>
  );
}
